import { render, staticRenderFns } from "./FilteredChips.vue?vue&type=template&id=39c90152&scoped=true&"
import script from "./FilteredChips.vue?vue&type=script&lang=js&"
export * from "./FilteredChips.vue?vue&type=script&lang=js&"
import style0 from "./FilteredChips.vue?vue&type=style&index=0&id=39c90152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c90152",
  null
  
)

export default component.exports